import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import CommonTable from '../../../../components/common-table/CommonTable';
import DemoUsersTableItem from './DemoUsersTableItem';
import Tr from '../../../../components/common-table/components/Tr';
import Th from '../../../../components/common-table/components/Th';
import ThWithSort from '../../../../components/common-table/components/ThWithSort';
import { changeDemoRecreateTableSettings } from '../../../../redux/user-management/userManagementReducer';
import calculateSortStr from '../../../../utils/calculateSortValue';
import CommonPagination from '../../../../components/common-pagination/CommonPagination';
import { getDemoRecreateUsers } from '../../../../redux/user-management/userManagementActions';

import scss from './DemoUsersTable.module.scss';

function DemoUsersTable() {
  const dispatch = useDispatch();
  const { t } = useTranslation('userManagement');

  const demoRecreateUsers = useSelector((state) => state.userManagement.demoRecreateUsers);
  const { page, size, sort, totalElements } = useSelector((state) => state.userManagement.demoRecreateTableSettings);
  const isLoading = useSelector((state) => state.userManagement.demoRecreateIsLoading);

  const handleChangeSort = (sortValue) => {
    dispatch(changeDemoRecreateTableSettings({ sort: calculateSortStr({ currentSort: sort, newSortKey: sortValue }) }));
  };

  const handleChangePage = (newPage) => {
    dispatch(changeDemoRecreateTableSettings({ page: newPage }));
  };

  useEffect(() => {
    if (typeof page !== 'undefined' && typeof size !== 'undefined' && typeof sort !== 'undefined') {
      dispatch(getDemoRecreateUsers());
    }
  }, [dispatch, page, size, sort]);

  return (
    <div className={scss.tableWrapper}>
      <CommonTable
        content={demoRecreateUsers}
        isLoading={isLoading}
        renderBody={(item, index) => (
          <DemoUsersTableItem key={item.id} user={item} rowRank={page * size + (index + 1)} />
        )}>
        <Tr>
          <Th extraClasses={scss.cellId}>#</Th>
          <ThWithSort
            label={t('name')}
            columnKey='userName'
            sortStr={sort}
            onSort={handleChangeSort}
            extraThClass={scss.cellLeft}
          />
          <ThWithSort
            label={t('company')}
            columnKey='companyName'
            sortStr={sort}
            onSort={handleChangeSort}
            extraThClass={scss.cellLeft}
          />
          <ThWithSort
            label={t('email')}
            columnKey='email'
            sortStr={sort}
            onSort={handleChangeSort}
            extraThClass={scss.cellLeft}
          />
          <Th extraClasses={scss.cellLeft}>{t('attempts')}</Th>
          <Th extraClasses={scss.cellLeft}>{t('fullAccess')}</Th>
          <Th extraClasses={scss.cellLeft}>{t('password')}</Th>
          <ThWithSort
            label={t('added')}
            columnKey='createdOn'
            sortStr={sort}
            onSort={handleChangeSort}
            extraThClass={scss.cellLeft}
          />
        </Tr>
      </CommonTable>

      <div className={scss.paginationWrapper}>
        <CommonPagination
          activePage={page}
          itemsPerPage={size}
          totalItemsCount={totalElements}
          onChangePage={handleChangePage}
        />
      </div>
    </div>
  );
}

export default DemoUsersTable;
